"use client";

import React, { useState } from "react";
import RichText from "@/components/organisms/Legacy/Richtext";
import "./styles.scss";

interface TableToggleProps {
  title: string;
  subtitle?: string;
  content?: string | TrustedHTML;
  richtext: any;
}

const TableToggle: React.FC<TableToggleProps> = ({ title, subtitle, content, richtext }) => {
  const [active, setActive] = useState(false);

  const toggleOpen = () => {
    setActive((prevActive) => !prevActive);
  };

  const headerActiveClass = active
    ? "tableToggle__header tableToggle__open"
    : "tableToggle__header";
  const iconActiveClass = active
    ? "tableToggle--icon tableToggle--icon__open"
    : "tableToggle--icon";
  const bodyActiveClass = active
    ? "tableToggle__body tableToggle__body__open"
    : "tableToggle__body";

  return (
    <div
      data-testid="table-toggle-content"
      className={subtitle ? "tableToggle" : "tableToggle tableToggle__light"}>
      <div
        className={headerActiveClass}
        onClick={toggleOpen}
        onKeyDown={toggleOpen}
        role="button"
        tabIndex={0}>
        {title}
        <div className="tableToggle--iconWrapper">
          <svg
            className={iconActiveClass}
            height="16"
            width="8"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 320 512">
            <path
              fill="#383C56"
              d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
            />
          </svg>
        </div>
      </div>
      <div
        className={bodyActiveClass}
        data-testid="table-toggle-body">
        {subtitle && <div className="tableToggle__subtitle">{subtitle}</div>}
        {content && <div dangerouslySetInnerHTML={{ __html: content }} />}
        <RichText content={richtext} />
      </div>
    </div>
  );
};

export default TableToggle;
